import ReactDOM from 'react-dom'
import { ReactElement } from 'react'

// Store original react dom render function
const renderer = ReactDOM.render

/**
 * @param {Element} element
 */
function unMountReactFromRootElement (element: Element & { _reactRootContainer?: any }): void {
  try {
    // console.log('FIX-UN-MOUNT: Un-mount react component at:', element, element._reactRootContainer)
    ReactDOM.unmountComponentAtNode(element)
  } catch (ex) { 
    //console.error(ex) 
  }
}

/**
 * @param {Node} node
 * @returns {boolean} Is react root
 */
function isNodeReactRoot (node: Node & { _reactRootContainer?: any }): boolean {
  return Object.keys(node).indexOf('_reactRootContainer') >= 0 && node._reactRootContainer !== null
}

/**
 * @param {MutationRecord} mutation
 */
function handleDomMutation (mutation: MutationRecord): void {
  Array
    .from(mutation.removedNodes)
    .filter(isNodeReactRoot)
    .map(unMountReactFromRootElement)
}

/**
 * @param {MutationRecord[]} mutations
 */
function handleDomMutations (mutations: MutationRecord[]): void {
  mutations.map(handleDomMutation)
}

/**
 * @param {Element} element
 */
function ensureUnMount (element: Element): void {
  const mutationObserver = new MutationObserver(handleDomMutations)
  mutationObserver.observe(element.parentElement, {
    childList: true,
  })
}

// This will wrap every react root in our application with a
// mutation observer on the parent element, listening for the
// react component container's removal from the DOM, so that it
// can properly un-mount the react instance if not already done.
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
ReactDOM.render = (element: ReactElement, container: Element) => {
  // console.log('FIX-UN-MOUNT: Rendering component react to:', container, element)
  if (!container) return;
  ensureUnMount(container)
  renderer(element, container)
}
